import React, {useContext} from 'react'
import {useTranslation} from '@modifi/plugin-i18n'
import {FormDataContext} from '@modifi/plugin-forms'

import {ConnectedFormFooter} from '../../../../plugins/onboarding/components/form-cta-footer'

type PersonFormFooterProps = {
  loading: boolean
  hasError: boolean
  submitLabel: string
  canMoveBack: boolean
  handleBackButtonClick: () => void
  isFinalStep?: boolean
}

const PersonFormFooter: React.FC<PersonFormFooterProps> = ({
  loading,
  hasError,
  submitLabel,
  canMoveBack,
  handleBackButtonClick,
  isFinalStep = true,
}) => {
  const {hasChanges} = useContext(FormDataContext)
  const {t} = useTranslation('charon')
  return (
    <ConnectedFormFooter
      loading={loading}
      hasError={hasError}
      isAlwaysVisible
      submitLabel={submitLabel}
      hasBackButton
      canMoveBack={canMoveBack}
      onBackButtonClick={handleBackButtonClick}
      disableSubmit={!hasChanges && submitLabel === t('sub-section-footer.cta-submit')}
      disableDiscard={!hasChanges}
      isFinalStep={isFinalStep}
    />
  )
}

export default PersonFormFooter
